;(function (window, document) {
  'use strict'

  var DEFAULT_STATES = ['inactive', 'active']
  var instanceCounter = 0

  function isElement(value) {
    return value && value.nodeType === 1
  }

  function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value)
  }

  function toArray(value) {
    return Array.prototype.slice.call(value)
  }

  function toElements(value, fallbackElement) {
    if (!value) {
      return fallbackElement ? [fallbackElement] : []
    }

    if (typeof value === 'string') {
      return toArray(document.querySelectorAll(value))
    }

    if (isElement(value)) {
      return [value]
    }

    if (value instanceof NodeList || Array.isArray(value)) {
      return toArray(value).filter(isElement)
    }

    return fallbackElement ? [fallbackElement] : []
  }

  function toElement(value, fallbackElement) {
    var elements = toElements(value, fallbackElement)

    return elements.length ? elements[0] : null
  }

  function toClassList(value) {
    if (!value) return []

    if (typeof value === 'string') {
      return value.trim().split(/\s+/).filter(Boolean)
    }

    if (Array.isArray(value)) {
      return value.join(' ').trim().split(/\s+/).filter(Boolean)
    }

    return []
  }

  function addClasses(element, classes) {
    toClassList(classes).forEach(function (className) {
      element.classList.add(className)
    })
  }

  function removeClasses(element, classes) {
    toClassList(classes).forEach(function (className) {
      element.classList.remove(className)
    })
  }

  function setAttributes(element, attrs) {
    if (!attrs) return

    Object.keys(attrs).forEach(function (attrName) {
      var value = attrs[attrName]

      if (value === false || value === null || typeof value === 'undefined') {
        element.removeAttribute(attrName)
      } else {
        element.setAttribute(attrName, String(value))
      }
    })
  }

  function normalizeName(value) {
    return String(value || '')
      .trim()
      .replace(/^[#.]/, '')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  function getStateAttributeName(name) {
    return 'data-state-' + normalizeName(name).toLowerCase()
  }

  function getNameFromSelector(selector) {
    if (!selector || typeof selector !== 'string') return ''

    var value = selector.trim()

    if (value === 'body') return 'body'

    if (value.charAt(0) === '#') {
      return normalizeName(value.slice(1))
    }

    if (value.charAt(0) === '.') {
      return normalizeName(value.slice(1).split(/[ .#[>:+~]/)[0])
    }

    return normalizeName(value.split(/[ .#[>:+~]/)[0])
  }

  function getNameFromElement(element) {
    if (!isElement(element)) return ''

    if (element === document.body) return 'body'
    if (element.id) return normalizeName(element.id)
    if (element.classList.length) return normalizeName(element.classList[0])

    return ''
  }

  function getStateAddClasses(stateConfig) {
    if (!stateConfig) return []

    if (typeof stateConfig === 'string' || Array.isArray(stateConfig)) {
      return toClassList(stateConfig)
    }

    if (typeof stateConfig === 'object') {
      return toClassList(stateConfig.add)
    }

    return []
  }

  function getStateRemoveClasses(stateConfig) {
    if (
      !stateConfig ||
      typeof stateConfig !== 'object' ||
      Array.isArray(stateConfig)
    ) {
      return []
    }

    return toClassList(stateConfig.remove)
  }

  function getBackdropDefaultClassName(type, fade) {
    var baseClass = type === 'modal' ? 'modal-backdrop' : 'offcanvas-backdrop'

    return fade === false ? baseClass : baseClass + ' fade'
  }

  function nextFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(callback)
    } else {
      setTimeout(callback, 0)
    }
  }

  function parseDataConfig(value) {
    if (!value) return {}

    var trimmed = value.trim()

    if (!trimmed) return {}

    if (trimmed.charAt(0) !== '{') {
      return {
        target: trimmed
      }
    }

    try {
      return JSON.parse(trimmed)
    } catch (error) {
      console.warn('[StateToggler] Invalid JSON in data-state-toggler:', error)
      return {}
    }
  }

  function StateToggler(trigger, options) {
    this.options = options || {}

    this.triggers = toElements(trigger || this.options.trigger)

    if (!this.triggers.length) {
      throw new Error('[StateToggler] Trigger element not found.')
    }

    this.targets = toElements(this.options.target, document.body)

    if (!this.targets.length) {
      this.targets = [document.body]
    }

    this.states =
      Array.isArray(this.options.states) && this.options.states.length
        ? this.options.states.slice()
        : DEFAULT_STATES.slice()

    this.name = this.getName()
    this.baseClass = /StateToggler$/.test(this.name)
      ? this.name
      : this.name + 'StateToggler'

    this.stateAttribute = getStateAttributeName(this.name)

    this.initial = this.options.initial || this.states[0]
    this.state = this.getInitialState()

    this.activeState =
      this.options.activeState ||
      (this.states.indexOf('active') !== -1
        ? 'active'
        : this.states[this.states.length - 1])

    this.group = this.options.group || null
    this.disabled = false
    this.resizeTimer = null
    this.backdropElement = null
    this.backdropTimer = null
    this.backdropConfig = this.getBackdropConfig()
    this.bindEvents = this.options.bindEvents !== false

    this.handleClick = this.handleClick.bind(this)
    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.handleBackdropClick = this.handleBackdropClick.bind(this)

    this.init()
  }

  StateToggler.prototype.init = function () {
    var self = this

    this.triggers.forEach(function (trigger) {
      if (self.bindEvents) {
        trigger.addEventListener('click', self.handleClick)
      }

      StateToggler.triggerMap.set(trigger, self)
    })

    if (this.options.resetOnWindowResize === true) {
      window.addEventListener('resize', this.handleWindowResize)
    }

    StateToggler.instances.push(this)

    this.applyState()
  }

  StateToggler.prototype.getName = function () {
    var optionName = normalizeName(this.options.name)

    if (optionName) {
      return optionName
    }

    var nameFromTargetSelector = getNameFromSelector(this.options.target)

    if (nameFromTargetSelector) {
      return nameFromTargetSelector
    }

    var nameFromTargetElement = getNameFromElement(this.targets[0])

    if (nameFromTargetElement) {
      return nameFromTargetElement
    }

    instanceCounter += 1

    return 'stateToggler' + instanceCounter
  }

  StateToggler.prototype.getInitialState = function () {
    var stateFromNamedAttr = this.triggers[0].getAttribute(this.stateAttribute)
    var stateFromOldAttr = this.triggers[0].getAttribute('data-state')

    if (stateFromNamedAttr && this.states.indexOf(stateFromNamedAttr) !== -1) {
      return stateFromNamedAttr
    }

    if (stateFromOldAttr && this.states.indexOf(stateFromOldAttr) !== -1) {
      return stateFromOldAttr
    }

    if (this.options.initial && this.states.indexOf(this.options.initial) !== -1) {
      return this.options.initial
    }

    return this.states[0]
  }

  StateToggler.prototype.getBackdropConfig = function () {
    var backdrop = this.options.backdrop
    var config = {}
    var type
    var fade
    var id

    if (backdrop === false || backdrop === null || typeof backdrop === 'undefined') {
      return {
        enabled: false
      }
    }

    if (backdrop === true) {
      config = {}
    } else if (backdrop === 'static') {
      config = {
        static: true
      }
    } else if (isObject(backdrop)) {
      config = backdrop
    } else {
      return {
        enabled: false
      }
    }

    if (config.enabled === false) {
      return {
        enabled: false
      }
    }

    type = config.type === 'modal' ? 'modal' : 'offcanvas'
    fade = config.fade !== false
    id = typeof config.id === 'undefined' ? this.name + 'Backdrop' : config.id

    return {
      enabled: true,
      type: type,
      id: id === false || id === null ? null : String(id),
      className: config.className || getBackdropDefaultClassName(type, fade),
      showClass:
        typeof config.showClass === 'undefined' ? 'show' : config.showClass,
      closeOnClick: config.closeOnClick !== false,
      static: config.static === true,
      container: config.container || document.body,
      states: Array.isArray(config.states) ? config.states.slice() : null,
      removeDelay:
        typeof config.removeDelay === 'number' ? config.removeDelay : 150,
      bodyClass: config.bodyClass || null,
      attributes: config.attributes || null,
      onClick: typeof config.onClick === 'function' ? config.onClick : null
    }
  }

  StateToggler.prototype.handleClick = function (event) {
    if (this.shouldPreventDefault(event)) {
      event.preventDefault()
    }

    this.toggle(event)
  }

  StateToggler.prototype.handleWindowResize = function (event) {
    var self = this

    clearTimeout(this.resizeTimer)

    this.resizeTimer = setTimeout(function () {
      self.reset(event)
    }, 150)
  }

  StateToggler.prototype.handleBackdropClick = function (event) {
    var context
    var clickResult

    if (!this.backdropElement || event.target !== this.backdropElement) {
      return
    }

    context = this.createContext(event, this.initial, this.state)
    context.backdrop = this.backdropElement

    this.emit('backdrop-click', context, false)

    if (this.backdropConfig.onClick) {
      clickResult = this.backdropConfig.onClick(context)

      if (clickResult === false || context.cancelled) {
        return
      }
    }

    if (this.backdropConfig.static || this.backdropConfig.closeOnClick === false) {
      this.emit('backdrop-static-click', context, false)
      return
    }

    this.close(event)
  }

  StateToggler.prototype.shouldPreventDefault = function (event) {
    if (!event || !event.currentTarget) return false

    if (this.options.preventDefault === true) {
      return true
    }

    if (this.options.preventDefault === false) {
      return false
    }

    var trigger = event.currentTarget
    var tagName = trigger.tagName.toLowerCase()

    if (tagName !== 'a') {
      return false
    }

    var href = trigger.getAttribute('href')

    return !href || href === '#'
  }

  StateToggler.prototype.toggle = function (event) {
    return this.setState(this.getNextState(event), event)
  }

  StateToggler.prototype.reset = function (event) {
    return this.setState(this.initial, event)
  }

  StateToggler.prototype.getNextState = function (event) {
    if (typeof this.options.next === 'function') {
      return this.options.next(this.createContext(event))
    }

    if (this.options.next && typeof this.options.next === 'object') {
      return this.options.next[this.state] || this.state
    }

    var currentIndex = this.states.indexOf(this.state)
    var nextIndex = currentIndex + 1

    if (nextIndex >= this.states.length) {
      nextIndex = 0
    }

    return this.states[nextIndex]
  }

  StateToggler.prototype.setState = function (nextState, event, meta) {
    meta = meta || {}

    if (this.disabled) {
      return false
    }

    if (this.states.indexOf(nextState) === -1) {
      console.warn('[StateToggler] Unknown state:', nextState)
      return false
    }

    if (nextState === this.state) {
      return true
    }

    var previousState = this.state
    var context = this.createContext(event, nextState, previousState)

    var beforeResult = this.callCallback('before', context)
    var beforeEventAllowed = this.emit('before', context, true)

    if (
      beforeResult === false ||
      beforeEventAllowed === false ||
      context.cancelled
    ) {
      this.emit('cancel', context, false)
      return false
    }

    if (
      !meta.skipGroup &&
      this.group &&
      this.options.closeOthers &&
      nextState !== this.initial
    ) {
      this.closeOtherGroupItems(event)
    }

    this.state = nextState

    context.currentState = this.state

    this.applyState()

    this.callCallback('onChange', context)
    this.emit('change', context, false)

    this.callCallback('after', context)
    this.emit('after', context, false)

    return true
  }

  StateToggler.prototype.createContext = function (
    event,
    nextState,
    previousState
  ) {
    var self = this

    return {
      instance: this,
      trigger: this.triggers[0],
      triggers: this.triggers,
      target: this.targets[0],
      targets: this.targets,
      body: document.body,
      backdrop: this.backdropElement,
      name: this.name,
      baseClass: this.baseClass,
      group: this.group,
      states: this.states.slice(),
      previousState: previousState || this.state,
      currentState: this.state,
      nextState: nextState || this.getNextState(event),
      event: event || null,
      config: this.options,
      cancelled: false,
      cancel: function () {
        self.cancelContext(this)
      }
    }
  }

  StateToggler.prototype.cancelContext = function (context) {
    context.cancelled = true
  }

  StateToggler.prototype.callCallback = function (name, context) {
    if (typeof this.options[name] === 'function') {
      return this.options[name](context)
    }

    return undefined
  }

  StateToggler.prototype.emit = function (name, context, cancelable) {
    var eventName = 'state-toggler:' + name
    var elements = this.triggers.concat(this.targets)
    var allowed = true

    elements.forEach(function (element) {
      var event = new CustomEvent(eventName, {
        bubbles: true,
        cancelable: Boolean(cancelable),
        detail: context
      })

      if (!element.dispatchEvent(event)) {
        allowed = false
      }
    })

    return allowed
  }

  StateToggler.prototype.closeOtherGroupItems = function (event) {
    var self = this

    StateToggler.instances.forEach(function (instance) {
      if (
        instance !== self &&
        instance.group === self.group &&
        instance.state !== instance.initial
      ) {
        instance.setState(instance.initial, event, {
          skipGroup: true
        })
      }
    })
  }

  StateToggler.prototype.applyState = function () {
    this.applySystemClasses()
    this.applyShortcutClasses()
    this.applyCustomClasses()
    this.applyA11y()
    this.applyCustomAttrs()
    this.applyBackdrop()
  }

  StateToggler.prototype.applySystemClasses = function () {
    var self = this
    var elements = this.triggers.concat(this.targets)

    elements.forEach(function (element) {
      element.classList.add(self.baseClass)

      self.states.forEach(function (state) {
        element.classList.remove(self.name + '--' + state)
        element.classList.remove(self.baseClass + '--' + state)
      })

      element.classList.add(self.name + '--' + self.state)
      element.classList.add(self.baseClass + '--' + self.state)

      element.setAttribute(self.stateAttribute, self.state)
    })
  }

  StateToggler.prototype.applyShortcutClasses = function () {
    var activeMap

    if (this.options.selfClass) {
      activeMap = {}
      activeMap[this.activeState] = this.options.selfClass
      this.applyClassMap(this.triggers, activeMap)
    }

    if (this.options.targetClass || this.options.class) {
      activeMap = {}
      activeMap[this.activeState] =
        this.options.targetClass || this.options.class
      this.applyClassMap(this.targets, activeMap)
    }

    if (this.options.bodyClass) {
      activeMap = {}
      activeMap[this.activeState] = this.options.bodyClass
      this.applyClassMap([document.body], activeMap)
    }
  }

  StateToggler.prototype.applyCustomClasses = function () {
    var classes = this.options.classes || {}
    var selectors = classes.selectors || {}
    var selector

    this.applyClassMap(this.triggers, classes.self)
    this.applyClassMap(this.targets, classes.target)
    this.applyClassMap([document.body], classes.body)

    for (selector in selectors) {
      if (Object.prototype.hasOwnProperty.call(selectors, selector)) {
        this.applyClassMap(toElements(selector), selectors[selector])
      }
    }
  }

  StateToggler.prototype.applyClassMap = function (elements, classMap) {
    var self = this

    if (!classMap || !elements.length) return

    elements.forEach(function (element) {
      self.states.forEach(function (state) {
        removeClasses(element, getStateAddClasses(classMap[state]))
      })

      removeClasses(element, getStateRemoveClasses(classMap[self.state]))
      addClasses(element, getStateAddClasses(classMap[self.state]))
    })
  }

  StateToggler.prototype.applyA11y = function () {
    if (this.options.a11y === false) return

    var isActive = this.state !== this.initial
    var firstTarget = this.targets[0]
    var hasSingleTarget = this.targets.length === 1
    var targetIsBody = firstTarget === document.body

    this.triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(isActive))

      if (hasSingleTarget && firstTarget.id && !targetIsBody) {
        trigger.setAttribute('aria-controls', firstTarget.id)
      }
    })

    this.targets.forEach(function (target) {
      if (target !== document.body && target !== document.documentElement) {
        target.setAttribute('aria-hidden', String(!isActive))
      }
    })
  }

  StateToggler.prototype.applyCustomAttrs = function () {
    var attrs = this.options.attrs || {}
    var selectors = attrs.selectors || {}
    var selector

    this.applyAttrMap(this.triggers, attrs.self)
    this.applyAttrMap(this.targets, attrs.target)
    this.applyAttrMap([document.body], attrs.body)

    for (selector in selectors) {
      if (Object.prototype.hasOwnProperty.call(selectors, selector)) {
        this.applyAttrMap(toElements(selector), selectors[selector])
      }
    }
  }

  StateToggler.prototype.applyAttrMap = function (elements, attrMap) {
    var self = this

    if (!attrMap || !elements.length) return

    elements.forEach(function (element) {
      Object.keys(attrMap).forEach(function (attrName) {
        var valueConfig = attrMap[attrName]
        var value = valueConfig

        if (valueConfig && typeof valueConfig === 'object') {
          value = valueConfig[self.state]
        }

        if (value === false || value === null || typeof value === 'undefined') {
          element.removeAttribute(attrName)
        } else {
          element.setAttribute(attrName, String(value))
        }
      })
    })
  }

  StateToggler.prototype.applyBackdrop = function () {
    if (!this.backdropConfig.enabled) return

    if (this.shouldShowBackdrop()) {
      this.showBackdrop()
    } else {
      this.hideBackdrop()
    }
  }

  StateToggler.prototype.shouldShowBackdrop = function () {
    var states = this.backdropConfig.states

    if (!states || !states.length) {
      return this.state !== this.initial
    }

    return states.indexOf(this.state) !== -1
  }

  StateToggler.prototype.showBackdrop = function () {
    var self = this
    var config = this.backdropConfig
    var container
    var element

    clearTimeout(this.backdropTimer)

    if (this.backdropElement) {
      addClasses(this.backdropElement, config.showClass)
      addClasses(document.body, config.bodyClass)
      return
    }

    container = toElement(config.container, document.body) || document.body
    element = document.createElement('div')

    if (config.id) {
      element.id = config.id
    }

    addClasses(element, config.className)
    setAttributes(element, config.attributes)

    element.addEventListener('click', this.handleBackdropClick)
    container.appendChild(element)

    this.backdropElement = element

    addClasses(document.body, config.bodyClass)

    nextFrame(function () {
      if (self.backdropElement === element) {
        addClasses(element, config.showClass)
      }
    })
  }

  StateToggler.prototype.hideBackdrop = function (instant) {
    var self = this
    var element = this.backdropElement
    var config = this.backdropConfig
    var removeDelay = instant ? 0 : config.removeDelay

    if (!element) return

    clearTimeout(this.backdropTimer)
    removeClasses(element, config.showClass)
    removeClasses(document.body, config.bodyClass)

    function removeElement() {
      element.removeEventListener('click', self.handleBackdropClick)

      if (element.parentNode) {
        element.parentNode.removeChild(element)
      }

      if (self.backdropElement === element) {
        self.backdropElement = null
      }
    }

    if (removeDelay <= 0) {
      removeElement()
    } else {
      this.backdropTimer = setTimeout(removeElement, removeDelay)
    }
  }

  StateToggler.prototype.getState = function () {
    return this.state
  }

  StateToggler.prototype.open = function (event) {
    return this.setState(this.activeState, event)
  }

  StateToggler.prototype.close = function (event) {
    return this.setState(this.initial, event)
  }

  StateToggler.prototype.enable = function () {
    this.disabled = false
  }

  StateToggler.prototype.disable = function () {
    this.disabled = true
  }

  StateToggler.prototype.destroy = function () {
    var self = this

    this.triggers.forEach(function (trigger) {
      trigger.removeEventListener('click', self.handleClick)
      StateToggler.triggerMap.delete(trigger)
    })

    window.removeEventListener('resize', this.handleWindowResize)
    clearTimeout(this.resizeTimer)
    clearTimeout(this.backdropTimer)
    this.hideBackdrop(true)

    StateToggler.instances = StateToggler.instances.filter(function (instance) {
      return instance !== self
    })
  }

  StateToggler.get = function (trigger) {
    var elements = toElements(trigger)

    if (!elements.length) return null

    return StateToggler.triggerMap.get(elements[0]) || null
  }

  StateToggler.toggle = function (trigger, options, event) {
    var instance = StateToggler.get(trigger)
    var config
    var key

    if (!instance) {
      config = {}

      options = options || {}

      for (key in options) {
        if (Object.prototype.hasOwnProperty.call(options, key)) {
          config[key] = options[key]
        }
      }

      config.bindEvents = false

      instance = new StateToggler(trigger, config)
    }

    return instance.toggle(event)
  }

  StateToggler.initAll = function (root) {
    root = root || document

    var elements = toArray(root.querySelectorAll('[data-state-toggler]'))

    elements.forEach(function (element) {
      if (StateToggler.triggerMap.has(element)) return

      var config = parseDataConfig(element.getAttribute('data-state-toggler'))

      new StateToggler(element, config)
    })
  }

  StateToggler.instances = []
  StateToggler.triggerMap = new WeakMap()

  window.StateToggler = StateToggler

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      StateToggler.initAll()
    })
  } else {
    StateToggler.initAll()
  }
})(window, document)
